<template>
  <DrawerModal>
    <section style="height: calc(100dvh - 32px)">
      <div class="flex flex-col justify-between h-full px-6">
        <h2
          class="mb-0 text-2xl italic font-bold text-black font-ff-good-pro-cond"
        >
          {{ $t("common.warranty_request") }}
        </h2>
        <div
          class="flex flex-col items-center justify-center flex-1 max-w-[333px] mx-auto text-center"
        >
          <WarrantyRequestSuccessIcon class="w-[198px]" />
          <h2
            class="font-bold text-[26px] mt-0 leading-[34px] mb-1 font-ff-good-pro-cond text-black"
          >
            {{ $t("common.warranty_request_submit_success") }}
          </h2>
          <p
            class="mb-0 text-base font-normal text-black font-ff-good-pro-cond max-w-[263px]"
          >
            {{ $t("common.warranty_request_submit_notice") }}
          </p>
        </div>
        <Btn
          type="button"
          size="lg"
          block
          @click="onBack"
          :rounded="false"
          class="mb-6 uppercase rounded-md"
          color="secondary"
          :disabled="isSending"
          v-text="$t('common.ok')"
        />
      </div>
    </section>
  </DrawerModal>
</template>

<script setup>
import { useVfm } from "vue-final-modal";
import WarrantyRequestSuccessIcon from "~/assets/svg/warranty-request-success.svg?component";

const vfm = useVfm();

function onBack() {
  vfm.closeAll();
}
</script>
<style>
</style>
